/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Store_Creatorcode_Nothanks2Inputs */

const id_store_creatorcode_nothanks2 = /** @type {(inputs: Store_Creatorcode_Nothanks2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak, terima kasih`)
};

const ms_store_creatorcode_nothanks2 = /** @type {(inputs: Store_Creatorcode_Nothanks2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak, terima kasih`)
};

const da_store_creatorcode_nothanks2 = /** @type {(inputs: Store_Creatorcode_Nothanks2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nej tak`)
};

const de_store_creatorcode_nothanks2 = /** @type {(inputs: Store_Creatorcode_Nothanks2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nein danke`)
};

const en_us2_store_creatorcode_nothanks2 = /** @type {(inputs: Store_Creatorcode_Nothanks2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No thanks`)
};

const es_es2_store_creatorcode_nothanks2 = /** @type {(inputs: Store_Creatorcode_Nothanks2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No, gracias`)
};

const es_mx2_store_creatorcode_nothanks2 = /** @type {(inputs: Store_Creatorcode_Nothanks2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No, gracias`)
};

const fil_store_creatorcode_nothanks2 = /** @type {(inputs: Store_Creatorcode_Nothanks2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hindi, salamat`)
};

const fr_store_creatorcode_nothanks2 = /** @type {(inputs: Store_Creatorcode_Nothanks2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non merci`)
};

const it_store_creatorcode_nothanks2 = /** @type {(inputs: Store_Creatorcode_Nothanks2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No grazie`)
};

const hu_store_creatorcode_nothanks2 = /** @type {(inputs: Store_Creatorcode_Nothanks2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nem, köszönöm`)
};

const nl_store_creatorcode_nothanks2 = /** @type {(inputs: Store_Creatorcode_Nothanks2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nee, bedankt`)
};

const no_store_creatorcode_nothanks2 = /** @type {(inputs: Store_Creatorcode_Nothanks2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nei takk`)
};

const pl_store_creatorcode_nothanks2 = /** @type {(inputs: Store_Creatorcode_Nothanks2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie, dziękuję`)
};

const pt_br2_store_creatorcode_nothanks2 = /** @type {(inputs: Store_Creatorcode_Nothanks2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não, obrigado`)
};

const pt_store_creatorcode_nothanks2 = /** @type {(inputs: Store_Creatorcode_Nothanks2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não, obrigado`)
};

const ro_store_creatorcode_nothanks2 = /** @type {(inputs: Store_Creatorcode_Nothanks2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nu, mulțumesc`)
};

const fi_store_creatorcode_nothanks2 = /** @type {(inputs: Store_Creatorcode_Nothanks2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ei kiitos`)
};

const sv_store_creatorcode_nothanks2 = /** @type {(inputs: Store_Creatorcode_Nothanks2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nej tack`)
};

const vi_store_creatorcode_nothanks2 = /** @type {(inputs: Store_Creatorcode_Nothanks2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không, cảm ơn`)
};

const tr_store_creatorcode_nothanks2 = /** @type {(inputs: Store_Creatorcode_Nothanks2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hayır, teşekkürler`)
};

const cs_store_creatorcode_nothanks2 = /** @type {(inputs: Store_Creatorcode_Nothanks2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ne, děkuji`)
};

const bg_store_creatorcode_nothanks2 = /** @type {(inputs: Store_Creatorcode_Nothanks2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не, благодаря`)
};

const ru_store_creatorcode_nothanks2 = /** @type {(inputs: Store_Creatorcode_Nothanks2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нет, спасибо`)
};

const uk_store_creatorcode_nothanks2 = /** @type {(inputs: Store_Creatorcode_Nothanks2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ні, дякую`)
};

const ar_store_creatorcode_nothanks2 = /** @type {(inputs: Store_Creatorcode_Nothanks2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا شكرًا`)
};

const hi_store_creatorcode_nothanks2 = /** @type {(inputs: Store_Creatorcode_Nothanks2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नहीं धन्यवाद`)
};

const th_store_creatorcode_nothanks2 = /** @type {(inputs: Store_Creatorcode_Nothanks2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่เป็นไร`)
};

const ja_store_creatorcode_nothanks2 = /** @type {(inputs: Store_Creatorcode_Nothanks2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`結構です`)
};

const zh_cn2_store_creatorcode_nothanks2 = /** @type {(inputs: Store_Creatorcode_Nothanks2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不用了`)
};

const zh_hant1_store_creatorcode_nothanks2 = /** @type {(inputs: Store_Creatorcode_Nothanks2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不用了`)
};

const ko_store_creatorcode_nothanks2 = /** @type {(inputs: Store_Creatorcode_Nothanks2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`괜찮습니다`)
};

/**
* | output |
* | --- |
* | "No thanks" |
*
* @param {Store_Creatorcode_Nothanks2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const store_creatorcode_nothanks2 = /** @type {((inputs?: Store_Creatorcode_Nothanks2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Store_Creatorcode_Nothanks2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_store_creatorcode_nothanks2(inputs)
	if (locale === "ms") return ms_store_creatorcode_nothanks2(inputs)
	if (locale === "da") return da_store_creatorcode_nothanks2(inputs)
	if (locale === "de") return de_store_creatorcode_nothanks2(inputs)
	if (locale === "en-US") return en_us2_store_creatorcode_nothanks2(inputs)
	if (locale === "es-ES") return es_es2_store_creatorcode_nothanks2(inputs)
	if (locale === "es-MX") return es_mx2_store_creatorcode_nothanks2(inputs)
	if (locale === "fil") return fil_store_creatorcode_nothanks2(inputs)
	if (locale === "fr") return fr_store_creatorcode_nothanks2(inputs)
	if (locale === "it") return it_store_creatorcode_nothanks2(inputs)
	if (locale === "hu") return hu_store_creatorcode_nothanks2(inputs)
	if (locale === "nl") return nl_store_creatorcode_nothanks2(inputs)
	if (locale === "no") return no_store_creatorcode_nothanks2(inputs)
	if (locale === "pl") return pl_store_creatorcode_nothanks2(inputs)
	if (locale === "pt-BR") return pt_br2_store_creatorcode_nothanks2(inputs)
	if (locale === "pt") return pt_store_creatorcode_nothanks2(inputs)
	if (locale === "ro") return ro_store_creatorcode_nothanks2(inputs)
	if (locale === "fi") return fi_store_creatorcode_nothanks2(inputs)
	if (locale === "sv") return sv_store_creatorcode_nothanks2(inputs)
	if (locale === "vi") return vi_store_creatorcode_nothanks2(inputs)
	if (locale === "tr") return tr_store_creatorcode_nothanks2(inputs)
	if (locale === "cs") return cs_store_creatorcode_nothanks2(inputs)
	if (locale === "bg") return bg_store_creatorcode_nothanks2(inputs)
	if (locale === "ru") return ru_store_creatorcode_nothanks2(inputs)
	if (locale === "uk") return uk_store_creatorcode_nothanks2(inputs)
	if (locale === "ar") return ar_store_creatorcode_nothanks2(inputs)
	if (locale === "hi") return hi_store_creatorcode_nothanks2(inputs)
	if (locale === "th") return th_store_creatorcode_nothanks2(inputs)
	if (locale === "ja") return ja_store_creatorcode_nothanks2(inputs)
	if (locale === "zh-CN") return zh_cn2_store_creatorcode_nothanks2(inputs)
	if (locale === "zh-Hant") return zh_hant1_store_creatorcode_nothanks2(inputs)
	return ko_store_creatorcode_nothanks2(inputs)
});
export { store_creatorcode_nothanks2 as "store.creatorCode.noThanks" }